import { HTTPService } from './HttpService';
import { Rating } from '../types';

export class RatingService {
  private httpService: HTTPService;

  constructor(httpService: HTTPService) {
    this.httpService = httpService;
  }

  async getPhotoRatings(photoId: number): Promise<Rating[]> {
    const response = await this.httpService.get(`/photos/${photoId}/ratings`);
    return response.data;
  }

  async setRating(photoId: number, stars: 1 | 2 | 3 | 4 | 5): Promise<Rating> {
    const response = await this.httpService.put(`/photos/${photoId}/rating`, { stars });
    return response.data;
  }

  async deleteRating(photoId: number): Promise<void> {
    await this.httpService.delete(`/photos/${photoId}/rating`);
  }
}
